import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { AiPreferences } from "../../api/commands/ai";
import * as AiChat from "../../widgets/aiChat";

export const Model = S.Struct({
	page: S.Literal("Chat"),
	chat: AiChat.Model,
	/** The circle's AI opt-out; the chat is replaced by a notice once it reads off. */
	ai: apiData(AiPreferences).schema,
});
export type Model = typeof Model.Type;
